import { useEffect, useState } from "react";
import { useNotify } from "ra-core";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { phoneEnabled, saveMyExtension } from "./phoneApi";
import { useMyExtension } from "./useMyExtension";

/** Profile section: which phone extension rings for me (drives the screen-pop and click-to-call). */
export function MyExtension() {
  const notify = useNotify();
  const { extension, salesId, refresh } = useMyExtension();
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => setValue(extension ?? ""), [extension]);
  if (!phoneEnabled || salesId == null) return null;

  const save = async () => {
    setSaving(true);
    try {
      await saveMyExtension(salesId, value);
      refresh();
      notify(
        value.trim() ? `Extension ${value.trim()} saved` : "Extension cleared",
        { type: "info" },
      );
      if (
        typeof Notification !== "undefined" &&
        Notification.permission === "default"
      ) {
        void Notification.requestPermission();
      }
    } catch (error: unknown) {
      notify(
        error instanceof Error ? error.message : "Could not save the extension",
        { type: "error" },
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card className="mt-4">
      <CardContent className="space-y-2">
        <h3 className="font-medium">My phone extension</h3>
        <p className="text-sm text-muted-foreground">
          Calls to this extension pop the caller&apos;s record on your screen,
          and the call button dials from it.
        </p>
        <div className="flex items-center gap-2">
          <Input
            value={value}
            onChange={(e) =>
              setValue(e.target.value.replace(/\D/g, "").slice(0, 4))
            }
            placeholder="e.g. 110"
            inputMode="numeric"
            className="w-28"
            aria-label="Extension"
          />
          <Button
            type="button"
            size="sm"
            disabled={saving || value === (extension ?? "")}
            onClick={() => void save()}
          >
            Save
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
